// extracted by mini-css-extract-plugin
export var serviceCard = "servicescard-module--serviceCard--2coEM";